import { useNavigate } from "react-router-dom";
import Car from "./Car";
import { useState, useEffect, useContext } from "react";
import { CarbonContext } from "../CarbonContext";

const Order = () => {
  const [orders, setOrders] = useState([]);
  const { token } = useContext(CarbonContext);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrders = async () => {
      if (!token.access_token) {
        navigate("/");
      }
      try {
        const response = await fetch(
          "https://carbon-j654.onrender.com/api/order",
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token.access_token}`,
            },
          }
        );

        if (response.ok) {
          const orders = await response.json();
          setOrders(orders);
        }
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };

    fetchOrders();
  }, [token, navigate]);

  return (
    <div>
      <div className="flex justify-center items-center text-white text-4xl font-bold my-5">
        All Orders
      </div>
      {orders.length === 0 ? (
        <div className="flex flex-col justify-center items-center min-h-[60vh] text-center px-4">
          <div className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            No Orders Found
          </div>
          <p className="text-gray-400 text-lg md:text-xl max-w-md mb-8">
            Looks like you haven't made any orders yet. Explore our luxury
            collection and find your perfect car.
          </p>
          <button
            onClick={() => navigate("/home")}
            className="px-6 py-3 text-sm md:text-base lg:text-lg bg-white text-black font-semibold rounded-lg hover:bg-gray-200 transition-colors duration-200"
          >
            Go to Home
          </button>
        </div>
      ) : (
        <Car cars={orders} isOrder={true} />
      )}
    </div>
  );
};

export default Order;
